<template>
  <div>
    <act-popup :active.sync="active" ref="actPopup" @save="save" />
  </div>
</template>

<script>
import ActPopup        from "@/components/calculated-program/acts/ActPopup_";
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:       "ActPopupNew",
  mixins:     [notifyHttpError],
  components: {
    ActPopup,
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    open() {
      try {
        this.$refs.actPopup.resetAct();
        this.active = true;
      } catch (e) {
        console.error(e);
      }
    },
    openWithType( type ) {
      try {
        this.$refs.actPopup.resetAct();
        this.active = true;

        this.$nextTick(() => {
          this.$refs.actPopup.setActType(type);
        });
      } catch (e) {
        console.error(e);
      }
    },
    openWithEntity( type, entity, actType = null ) {
      try {
        this.$refs.actPopup.resetAct();
        this.$refs.actPopup.actTypeEntityFilter = type;

        let newAct = {
          id:          null,
          main:        {
            buildings_id: this.selectedHouseId,
          },
          entity_type: type,
          entity_id:   entity.id,
          history:     [],
          files:       [],
          parameters:  {},
        };
        if (type === 'apartment') {
          newAct.apartment = {
            id: entity.id,
          };
        }

        if (type === 'device') {
          newAct.device = entity;
        }
        this.active = true;
        this.$nextTick(() => {
          this.$refs.actPopup.setAct(newAct);
          if (actType !== null) {
            this.$refs.actPopup.setActType(actType);
          }
        });
      } catch (e) {
        console.error(e);
      }
    },
    async save( { act } ) {
      let createBody = new FormData();
      createBody.append('buildings_id', act.main.buildings_id);
      createBody.append('act_type', act.main.act_type);
      createBody.append('entity_type', act.entity_type);
      createBody.append('entity_id', act.entity_id);
      createBody.append('comment', act.main.comment);
      createBody.append('parameters', JSON.stringify(act.parameters));

      for (let i = 0; i < act.files.uploaded.length; i++) {
        let file = act.files.uploaded[i];
        createBody.append(`act_files[${i}]`, file);
      }

      return this.$http.post('acts', createBody).then(
        ( { data } ) => {
          this.active = false;
          this.$vs.notify({ color: 'success', title: 'Успешное сохранение', text: 'Акт создан' });
          this.$emit('created', data.id);
        },
        this.notifyHttpError,
      );
    },
  },
};
</script>
